// ebookData.js
import dataEntryimg from '../../assets/data entry guide.png'
const eBooks = [
  {
    id: 1,
    title: "Online Data Entry Guide",
    description:
      "Master Data Entry in Two Weeks is a concise, beginner-friendly eBook designed to help you quickly build essential data entry skills. It covers typing accuracy, spreadsheet management, data formatting, and basic tools like Excel and Google Sheets. With daily exercises and practical tips, this guide ensures steady progress in just 14 days. Perfect for job seekers, freelancers, and anyone looking to boost their computer proficiency fast.",
    price: "₹1499",
    rating: 4.5,
    sellerTag: "Best Seller",
    image:dataEntryimg,
    pages:34,
    author:"Abhishek Sharma"
  },
  {
    id: 2,
    title: "React Pro Series",
    description: "Modern React development with hooks and best practices",
    price: "₹499",
    rating: 4.7,
    sellerTag: "Best Seller",
    image:
      "https://images.unsplash.com/photo-1633356122544-f134324a6cee?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80",
  },
  {
    id: 3,
    title: "Node.js Expert",
    description: "Enterprise-grade Node.js development strategies",
    price: "₹999",
    rating: 4.8,
    sellerTag: "Best Seller",
    image:
      "https://images.unsplash.com/photo-1542903660-eedba2cda473?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80",
  },
];

export default eBooks;
